import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const statesJSON = async (): Promise<any> => {
  const states = useJSONStore.getState().states;
  const token = useUserStore.getState().userToken;
  const setStates = useJSONStore.getState().setStates;

  if (states.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.state}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setStates(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default statesJSON;
